import React from "react";
import AgencyElements from "./agency-elements";

const DisplayTemplate = ({agencies, token}) => (
    <div
  aria-label="An email from Piedmont Natural Gas"
  lang="en"
  style={{ backgroundColor: "#f9fafa", width: "100%" }}
>
  <table
    width="100%"
    align="center"
    cellPadding={0}
    cellSpacing={0}
    border={0}
    role="presentation"
    style={{ minWidth: "100%" }}
  >
    <tbody>
      <tr>
        <td bgcolor="#f9fafa">
          <table
            width="100%"
            align="center"
            cellPadding={0}
            cellSpacing={0}
            border={0}
            role="presentation"
            style={{ width: "100%", maxWidth: 702 }}
          >
            <tbody>
              <tr>
                <td>
                  <table
                    width="100%"
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                    border={0}
                    role="presentation"
                    style={{ minWidth: "100%" }}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#dfe4e4">
                          <table
                            width="100%"
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                            border={0}
                            role="presentation"
                            style={{ width: "100%", maxWidth: 700 }}
                          >
                            <tbody>
                              <tr>
                                <td bgcolor="#ffffff">
                                  <table
                                    align="center"
                                    width="100%"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                    role="presentation"
                                    style={{ minWidth: "100%" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#ffffff"
                                          style={{ padding: "16px 24px" }}
                                        >
                                          <table
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                            style={{ minWidth: "100%" }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  align="left"
                                                  valign="middle"
                                                >
                                                  <a
                                                    href="https://www.piedmontng.com"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ display: "block" }}
                                                  >
                                                    <img
                                                      src="https://emails.duke-energy.com/brand/logos/logo-png.png"
                                                      width={100}
                                                      height={32}
                                                      border={0}
                                                      alt="Piedmont Natural Gas"
                                                      style={{
                                                        display: "block",
                                                        height: "auto",
                                                        fontFamily:
                                                          "Arial,sans-serif",
                                                        fontSize: 15,
                                                        // lineHeight: 23,
                                                        textAlign: "left",
                                                        color: "#696969"
                                                      }}
                                                    />
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table
                                    align="center"
                                    width="100%"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                    role="presentation"
                                    style={{ minWidth: "100%" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#f3fbfd"
                                          style={{ padding: "32px 24px" }}
                                        >
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                            style={{
                                              width: "100%",
                                              maxWidth: 500
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h1
                                                    style={{
                                                      margin: 0,
                                                      fontFamily:
                                                        "Arial,sans-serif",
                                                      fontSize: 29,
                                                      // lineHeight: 35,
                                                      fontWeight: "normal",
                                                      color: "#005984"
                                                    }}
                                                  >
                                                    Your personalized list
                                                    of&nbsp;agencies
                                                  </h1>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table
                                    align="center"
                                    width="100%"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                    role="presentation"
                                    style={{ minWidth: "100%" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#ffffff"
                                          style={{
                                            padding: "32px 24px 16px 24px"
                                          }}
                                        >
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                            style={{
                                              width: "100%",
                                              maxWidth: 500
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    fontFamily:
                                                      "Arial,sans-serif",
                                                    fontSize: 15,
                                                    // lineHeight: 23,
                                                    fontWeight: "normal",
                                                    color: "#696969"
                                                  }}
                                                >
                                                  {agencies.program && agencies.program === "png_hyperlocal" ? 
                                                  <p style={{ margin: 0, textAlign: "justify" }}>
                                                    Local agencies may have funding available to provide utility bill assistance in your area. This list is generated specifically for you based on your needs.
                                                  </p> :
                                                  <>
                                                    <p style={{ margin: 0, textAlign: "justify" }}>
                                                      Thank you for contacting Piedmont Natural Gas. As requested, below is a list of agencies that may be able to provide assistance.
                                                    </p>
                                                    <p
                                                      style={{
                                                        margin: "16px 0 0 0",
                                                        textAlign: "justify"
                                                      }}
                                                    >
                                                      Piedmont Natural Gas cannot make promises on behalf of any of the assistance agencies listed below. However, this list is generated specifically for you based on your needs.
                                                    </p>
                                                  </>}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table
                                    align="center"
                                    width="100%"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                    role="presentation"
                                    style={{ minWidth: "100%" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#ffffff"
                                          style={{ padding: "0 24px" }}
                                        >
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                            style={{
                                              width: "100%",
                                              maxWidth: 564
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  bgcolor="#ffffff"
                                                  style={{ padding: 20, display: "grid", gap: 5, }}
                                                >
                                                  {!!agencies && 
                                                    <AgencyElements agencies={agencies.packet} token={token}/>}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table
                                    align="center"
                                    width="100%"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                    role="presentation"
                                    style={{ minWidth: "100%" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#ffffff"
                                          style={{
                                            padding: "16px 24px 32px 24px"
                                          }}
                                        >
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                            style={{
                                              width: "100%",
                                              maxWidth: 500
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    fontFamily:
                                                      "Arial,sans-serif",
                                                    fontSize: 15,
                                                    // lineHeight: 23,
                                                    fontWeight: "normal",
                                                    color: "#696969"
                                                  }}
                                                >
                                                  <p style={{ margin: 0, textAlign: "justify" }}>
                                                    Please do not respond directly to this email as this mailbox is not monitored. For questions or other assistance, you can reach us via these <a href="https://www.piedmontng.com/customer-service">contact methods</a>.
                                                  </p>
                                                  <p
                                                    style={{
                                                      margin: "16px 0 24px 0"
                                                    }}
                                                  >
                                                    Sincerely,
                                                    <br />
                                                    Piedmont Natural Gas
                                                  </p>
                                                  <table
                                                    align="center"
                                                    width="100%"
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    role="presentation"
                                                    style={{ minWidth: "100%" }}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            borderBottom:
                                                              "1px solid #d7d9da"
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              display: "none",
                                                              fontSize: 1,
                                                              color: "#ffffff",
                                                              // lineHeight: 1,
                                                              fontFamily:
                                                                "sans-serif",
                                                              maxHeight: 0,
                                                              maxWidth: 0,
                                                              opacity: 0,
                                                              overflow:
                                                                "hidden",
                                                              msoHide: "all"
                                                            }}
                                                          >
                                                            &nbsp;
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                  {agencies.program && agencies.program === "png_hyperlocal" && 
                                                    <p
                                                      style={{
                                                        fontSize: 12,
                                                        textAlign: "justify"}}
                                                    >
                                                      Piedmont Natural Gas cannot guarantee any financial assistance. Listed agencies may not have funding available. Available financial assistance could be limited to eligible customers who meet poverty guidelines and is administered at the full discretion of assistance agencies.
                                                    </p>
                                                  }
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table
                                    align="center"
                                    width="100%"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                    role="presentation"
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#005984"
                                          align="center"
                                          style={{ paddingBottom: 32 }}
                                        >
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  bgcolor="#005984"
                                                  align="center"
                                                  style={{
                                                    padding: "32px 16px",
                                                    borderBottomStyle: "solid",
                                                    borderBottomWidth: 1,
                                                    borderBottomColor:
                                                      "#00789e",
                                                  }}
                                                >
                                                  <img
                                                    src="https://emails.duke-energy.com/brand/taglines/tagline-bsef.png"
                                                    alt="Building a Smarter Energy Future"
                                                    width={254}
                                                    height={14}
                                                    style={{
                                                      width: 254,
                                                      height: "auto",
                                                      fontFamily:
                                                        "Arial,sans-serif",
                                                      fontSize: 15,
                                                      // lineHeight: 24,
                                                      fontWeight: "normal",
                                                      textAlign: "center",
                                                      color: "#f2f4f4"
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                            style={{ minWidth: "100%" }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  bgcolor="#005984"
                                                  style={{
                                                    padding:
                                                      "32px 16px 0px 16px"
                                                  }}
                                                >
                                                  <table
                                                    align="center"
                                                    width="auto"
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    role="presentation"
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            padding: "0px 16px"
                                                          }}
                                                        >
                                                          <a
                                                            className="footer-social-link"
                                                            href="https://www.facebook.com/PiedmontNG"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            name="footer_facebook_icon"
                                                            style={{
                                                              display: "block"
                                                            }}
                                                          >
                                                            <img
                                                              className="social-icon"
                                                              src="https://emails.duke-energy.com/brand/socials/social-facebook.png"
                                                              width={20}
                                                              height={20}
                                                              border={0}
                                                              alt="Facebook"
                                                              style={{
                                                                display:
                                                                  "block",
                                                                fontFamily:
                                                                  "Arial,sans-serif",
                                                                fontSize: 16,
                                                                // lineHeight: 24,
                                                                textAlign:
                                                                  "center",
                                                                color: "#ffffff"
                                                              }}
                                                            />
                                                          </a>
                                                        </td>
                                                        <td
                                                          style={{
                                                            padding: "0px 16px"
                                                          }}
                                                        >
                                                          <a
                                                            className="footer-social-link"
                                                            href="https://twitter.com/PiedmontNG"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            name="footer_twitter_icon"
                                                            style={{
                                                              display: "block"
                                                            }}
                                                          >
                                                            <img
                                                              className="social-icon"
                                                              src="https://emails.duke-energy.com/brand/socials/social-twitter.png"
                                                              width={20}
                                                              height={20}
                                                              border={0}
                                                              alt="Twitter"
                                                              style={{
                                                                display:
                                                                  "block",
                                                                fontFamily:
                                                                  "Arial,sans-serif",
                                                                fontSize: 16,
                                                                // lineHeight: 24,
                                                                textAlign:
                                                                  "center",
                                                                color: "#ffffff"
                                                              }}
                                                            />
                                                          </a>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  bgcolor="#005984"
                                                  align="center"
                                                  style={{
                                                    padding: "32px 16px 0 16px",
                                                    fontFamily:
                                                      "Arial,sans-serif",
                                                    fontSize: 11,
                                                    // lineHeight: 16,
                                                    color: "#f2f4f4"
                                                  }}
                                                >
                                                  <a
                                                    className="link"
                                                    href="https://www.piedmontng.com/legal/privacy"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    name="footer_de_privacy_policy"
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      color: "#f2f4f4"
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "#f2f4f4"
                                                      }}
                                                    >
                                                      Privacy Policy
                                                    </span>
                                                  </a>
                                                  <span aria-hidden="true">
                                                    &nbsp;|&nbsp;
                                                  </span>
                                                  <a
                                                    className="link"
                                                    href="https://www.piedmontng.com"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    name="footer_de_home"
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      color: "#f2f4f4"
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "#f2f4f4"
                                                      }}
                                                    >
                                                      piedmontng.com
                                                    </span>
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            style={{ minWidth: "100%" }}
                                            role="presentation"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  bgcolor="#005984"
                                                  align="center"
                                                  style={{
                                                    padding: "16px 16px 0 16px",
                                                    fontFamily:
                                                      "Arial,sans-serif",
                                                    fontSize: 11,
                                                    // lineHeight: 16,
                                                    color: "#f2f4f4"
                                                  }}
                                                >
                                                  525 South Tryon Street{" "}
                                                  <span>&nbsp;|&nbsp;</span>{" "}
                                                  Charlotte, NC 28202
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table
                                            align="center"
                                            width="100%"
                                            border={0}
                                            cellPadding={0}
                                            cellSpacing={0}
                                            role="presentation"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  bgcolor="#005984"
                                                  align="center"
                                                  style={{
                                                    padding:
                                                      "16px 16px 0px 16px",
                                                    fontFamily:
                                                      "Arial,sans-serif",
                                                    fontSize: 11,
                                                    // lineHeight: 16,
                                                    color: "#f2f4f4"
                                                  }}
                                                >
                                                  © Piedmont Natural Gas Corporation. All
                                                  Rights Reserved.
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>
);

export default DisplayTemplate;